import { memo, useContext, useEffect, useMemo, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'
import { postRequest } from '../../../services/base'
import { MemoContext, SHOW_FETCH_MEMO_POPUP } from './context/context'
import Button from '../../common/Button'
import { Flex, Modal, Space } from 'antd'
import MemoTable from './MemoTable'
import { CloseOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const TracerMemos = ({ getListData }) => {
  let { vehicle } = useParams()
  const intl = useIntl()

  const [memos, setMemos] = useState([])
  const [atMemos, setAtMemos] = useState({})
  const [memoList, setMemoList] = useState([])
  const [totalMemos, setTotalMemos] = useState(10)
  const [crowdSource, setCrowdSource] = useState({})
  const [selectedItem, setSelectedItem] = useState({})
  const [recordType, setRecordType] = useState('new')

  const [state, dispatch] = useContext(NavContext)
  const [memoState, memoDispatch] = useContext(MemoContext)

  useEffect(() => {
    if (memoState.show_fetch_memo_popup) {
      setRecordType('new')
      importAllFromTracer()
    }
  }, [memoState.show_fetch_memo_popup])

  const importAllFromTracer = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'memos.fetchingFromTracer' }),
        showLoader: true,
      },
      notification: {},
    })

    let formData = new FormData()
    formData.append(
      'updated_after',
      memoState.memos_date ? memoState.memos_date : ''
    )

    let res = await postRequest(
      `/api/dtc_memos/tracer_memos/${vehicle}/`,
      formData
    )
    if (res?.status) {
      if (!res.data.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.data.data,
          },
        })
      } else {
        setCrowdSource(res.crowd_src_memo_log)
        setMemoList(res.data.data.memos)
        setMemos(
          filterMemos(res.data.data.memos, res.at_memos, res.crowd_src_memo_log)
        )
        setAtMemos(res.at_memos)
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: intl.formatMessage({ id: 'memos.fetchCompleted' }),
          },
        })
      }
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'memos.importError' }),
        },
      })
    }
  }

  const filterMemos = (
    tracerMemos,
    atMemos,
    crowdMemoLog,
    filterType = 'new'
  ) => {
    if (filterType == 'new') {
      return tracerMemos.filter(
        (memo) =>
          (memo.memo != atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.memo ||
            memo.short_desc !=
              atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.description.substring(
                0,
                128
              )) &&
          new Date(memo.updated_at) >=
            new Date(
              crowdMemoLog?.[`${memo?.dtc}_${memo?.acronym}`]?.updated_at
                ? crowdMemoLog?.[`${memo?.dtc}_${memo?.acronym}`]?.updated_at
                : null
            )
      )
    } else {
      return tracerMemos.filter(
        (memo) =>
          memo.memo != atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.memo ||
          memo.short_desc !=
            atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.description.substring(
              0,
              128
            )
      )
    }
  }

  const loadMoreMemos = () => {
    if (memos.length > totalMemos) {
      setTotalMemos(totalMemos + 10)
    }
  }

  const memoAction = async (action, index) => {
    const reqUrl = (action === 'accept') ? (
      `/api/dtc_memos/action/accept/${vehicle}/`
    ) : (
      `/api/dtc_memos/action/reject/${vehicle}/`
    )
    const res = await postRequest(reqUrl, selectedItem)
    
    // Update "memos" if request was successfull
    if(res?.status) {
      setMemos((prev) => {
        // Accept
        if(action === 'accept') {
          return prev.filter((_, i) => i !== index)
        }
        // Reject
        return prev.map((memo, i) => {
          return (i === index) ? {
            ...memo,
            status: 'rejected',
          } : memo
        })
      })
    }
    
    dispatch({
      type: 'notification',
      data: {
        notification_type: res?.status ? 'success' : 'error',
        msg: intl.formatMessage({
          id: res?.status ? 'memos.updateSuccess' : 'memos.updateFailed',
        }),
      },
    })
  }

  const filterRecords = (filterType) => {
    setMemos(filterMemos(memoList, atMemos, crowdSource, filterType))
    setRecordType(filterType)
  }

  const dataSource = useMemo(() => {
    if (!memos?.length) return []

    return memos.slice(0, totalMemos)?.map((memo, index) => {
      return {
        ...memo,
        rowKey: `memo-${memo.id}-${memo?.dtc}-${memo?.acronym}`,
        key: `memo-${index}`,
        dtc_name: memo.dtc_obj?.name ?? memo.dtc,
        index: index,

        atMemo: atMemos?.[`${memo?.dtc}_${memo?.acronym}`],
      }
    })
  }, [memos, totalMemos])

  const handleModalClose = () => {
    getListData()
    memoDispatch({ type: SHOW_FETCH_MEMO_POPUP, data: false })
  }

  return (
    <Modal
      open={memoState.show_fetch_memo_popup}
      title={
        <Flex justify="space-between" align="center">
          <h1>{intl.formatMessage({id: "memos.crowdsourcedMemosReview"})}</h1>

          <Space size={'middle'}>
            {recordType == 'new' ? (
              <Button
                onClick={(e) => {
                  filterRecords('all', state?.tracer_mappings)
                }}
              >
                {intl.formatMessage({id: "memos.showAllRecords"})}
              </Button>
            ) : (
              <Button
                onClick={(e) => {
                  filterRecords('new', state?.tracer_mappings)
                }}
              >
                {intl.formatMessage({id: "memos.showNewRecords"})}
              </Button>
            )}

            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={handleModalClose}
            />
          </Space>
        </Flex>
      }
      width="80%"
      // height='calc(100vh - 100px)'
      className="crowdsourced-memo-modal"
      centered={true}
      footer={null}
      closable={false}
      onCancel={handleModalClose}
    >
      <MemoTable
        dataSource={dataSource}
        showAction={true}
        pagination={false}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        memoAction={(action, index) => {
          memoAction(action, index)
        }}
        totalMemos={memos.length}
        {...(memos.length > totalMemos
          ? {
              loadMoreMemos: loadMoreMemos,
            }
          : {})}
      />
    </Modal>
  )
}

export default TracerMemos
